import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { IApiPagination } from "../../../interfaces/IPagination";
import {
  GetShippingCostsResponse,
  ShippingCost,
  TShippingCostFilter,
} from "../../../interfaces/shippingCostType";
import axiosTeethTab from "../../../services/apiCall";

type ShippingCostApiInterface = {
  getShippingCosts: (
    filter: TShippingCostFilter,
    pagination: IApiPagination,
  ) => Promise<ApiResponse<GetShippingCostsResponse>>;
  saveShippingCost: (
    shippingCost: ShippingCost,
  ) => Promise<ApiResponse<ShippingCost>>;
  getShippingCostById: (id: string) => Promise<ApiResponse<ShippingCost>>;
  enable: (id: string) => Promise<ApiResponse<ShippingCost>>;
  disable: (id: string) => Promise<ApiResponse<ShippingCost>>;
};

export const shippingCostApi: ShippingCostApiInterface = {
  getShippingCosts: async (filter, pagination) => {
    return await axiosTeethTab.get("shipping-costs/filter", {
      params: { filter, pagination },
    });
  },
  saveShippingCost: async (shippingCost) => {
    const endpoint = shippingCost._id
      ? `shipping-costs/${shippingCost._id}`
      : "shipping-costs";
    return await axiosTeethTab.post<ShippingCost>(endpoint, shippingCost);
  },
  getShippingCostById: async (id: string) => {
    return await axiosTeethTab.get<ShippingCost>(`shipping-costs/${id}`);
  },
  enable: async (id: string) => {
    return await axiosTeethTab.patch<ShippingCost>(`shipping-costs/${id}/enable`);
  },
  disable: async (id: string) => {
    return await axiosTeethTab.patch<ShippingCost>(`shipping-costs/${id}/disable`);
  },
};
